<template>
  <layout-main-inner title="批次信息">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template
        v-if="userPermission.ENT"
        slot="title">
        <create-batch-btn />
      </template>
      <template slot="form">
        <!-- <assign-ent-select
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          v-model="config.vendorId"
          immediate
          style="margin-right: 10px"
          :option="{}"
          :callback="() => {handleCurrentChange(1)}" /> -->
        <!-- <el-input placeholder="请输入商品名称"
          v-model="config.productName"
          style="width: 200px">
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input> -->
        <ent-product-auto-select
          v-model="config.productId"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model="config.batchCode"
          placeholder="请输入产品批次号"
          clearable=""
          style="width: 200px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="批次号"
          :resizable="false"
          width="200">
          <template slot-scope="{row}">
            <link-route
              :link-to="`/batch-detail?vendorId=${row.vendorId}&batchId=${row.batchId}&productId=${row.productId}`">
              {{ row.batchCode }}
            </link-route>
            <el-tag
              v-if="row.needSyncInventory === 0"
              type="danger">样品</el-tag>
            <!-- <span v-else>{{ row.batchCode }}</span> -->
            <!-- <el-tag
              v-if="row.needSyncInventory === 0 === 9"
              type="danger">紧急召回</el-tag>
            <el-tag
              v-if="row.status === 3"
              type="success">检验通过</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column
          label="产品名称"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.productName }}<span v-if="row.productNameRemark">({{ row.productNameRemark }})</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          label="企业名称"
          prop="vendorName"></el-table-column> -->
        <el-table-column
          label="起止序号"
          :resizable="false"
          width="210">
          <template slot-scope="{row}">
            <template v-if=" row.codingType !== 9">
              <span v-if="row.tagModel === 1">{{ row.beginTagNo | tagCount() }} - {{ row.endTagNo | tagCount() }}</span>
              <div v-if="row.tagModel === 2">

                <span>{{ row.beginSetNo | tagCount() }} - {{ row.endSetNo | tagCount() }}</span>
                <el-tag>箱</el-tag>
              </div>
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="已出库/总数"
          :resizable="false"
          width="100"
          prop="goodsCount">
          <template slot-scope="{row}">
            {{ row.outGoodsCount || 0 }}/{{ row.goodsCount }}
          </template>
        </el-table-column> -->
        <el-table-column
          label="是否贴码"
          :resizable="false"
          width="80"
          prop="codingType">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.codingType === 9 "
              type="danger">无码</el-tag>
            <el-tag v-else>有码</el-tag>
            <!-- {{ row.codingType === 9 ? '无码': '有码' }} -->
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="出库数量"
          :resizable="false"
          width="80">
          <template slot-scope="{row}">
            <span v-if="row.outGoodsCount !== null">{{ row.outGoodsCount }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="赋码方式"
          width="90">
          <template slot-scope="{row}">
            {{ row.codingType | codingType() }}
          </template>
        </el-table-column>
        <el-table-column
          label="建批模式"
          width="90">
          <template slot-scope="{row}">
            {{ row.tagModel | tagModel() }}
          </template>
        </el-table-column> -->
        <el-table-column
          label="创建时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="{row}">
            <el-button
              v-if="row.outGoodsCount === null"
              type="warning"
              @click="deleteProduct(row)">删除</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          :resizable="false"
          :width="90"> -->
        <!-- <template
            slot="header"
            slot-scope="{column}">
            {{ column.label }}
            <el-tooltip
              effect="dark"
              content="标签数量小于等于50个，可在线编辑设备识别码，大于50个时，建议下载模板进行编辑"
              placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template> -->
        <!-- <template slot-scope="{row}"> -->
        <!-- <template v-if="userPermission.OPERATE">
              <el-button
                type="text"
                @click="preview(row)">扫码预览</el-button>
              <el-button
                type="text"
                @click="deleteProduct(row)">删除</el-button>
            </template>
            <template v-if="userPermission.SUPERVISE && row.status !== 9">
              <el-button
                type="text"
                @click="recall(row)">召回</el-button>
            </template> -->
        <!-- <div v-if="userPermission.ENT"> -->
        <!-- <el-button type="text"
                style="margin-right: 5px;"
                v-if="row.status !== 9 && row.status !== 3"
                @click="deleteProduct(row)">删除</el-button> -->
        <!-- <el-dropdown
                v-if="row.status !== 0 && row.codingType ===1"
                @command="deviceActions">
                <el-button
                  type="text"
                  style="margin-right: 10px;">
                  商品识别码<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{row, actions: 1}">下载模板</el-dropdown-item>
                  <el-dropdown-item :command="{row, actions: 2}">上传</el-dropdown-item>
                  <el-dropdown-item :command="{row, actions: 3}">{{ row.editable ? '查看/编辑' : '查看' }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
        <!-- <link-route v-if="row.status === 0"
                style="margin-left: 5px;"
                :link-to="`/batch-update?vendorId=${row.vendorId}&batchId=${row.batchId}`">
                完善信息
              </link-route> -->
        <!-- <el-dropdown>
                <el-button type="primary">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown"> -->
        <!-- <el-dropdown-item
                    v-if="row.status === 0"
                    @click.native="addInfo(row)">完善信息</el-dropdown-item> -->
        <!-- <el-dropdown-item
                    v-if="row.status !== 9 && row.status !== 3"
                    @click.native="deleteProduct(row)">删除</el-dropdown-item> -->
        <!-- <el-dropdown-item
                    v-if="row.tagType === 1"
                    @click.native="downloadCode(row)">下载定制码</el-dropdown-item> -->
        <!-- <el-dropdown-item
                    v-if="row.status !== 0"
                    @click.native="preview(row)">扫码预览</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
        <!-- <el-button type="text"
                style="margin-left: 5px;"
                v-if="row.tagType === 1"
                @click="downloadCode(row)">下载定制码</el-button>
              <el-button type="text"
                style="margin-left: 5px;"
                v-if="row.status !== 0"
                @click="downloadCode(row)">预览</el-button> -->
        <!-- </div>
          </template>
        </el-table-column> -->
      </el-table>
      <el-upload
        ref="elUpload"
        action=""
        :limit="1"
        style="display:none"
        accept=".xls,.xlsx"
        :show-file-list="false"
        :http-request="handleHttpRequest">
        <i ref="upload"></i>
      </el-upload>
      <device-modal ref="modal" />
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <batch-qr-code-modal ref="qrcode" />
  </layout-main-inner>
</template>

<script>
import DeviceModal from './busi/device-modal.vue'
// import AssignEntSelect from '@/components/business/assign-ent-select.vue'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import BatchQrCodeModal from './busi/batch-qr-code-modal.vue'
import CreateBatchBtn from './busi/create-batch-btn.vue'
import { mapState } from 'vuex'
const TAG_COUNT = 50 // 设备识别码 tagCount >50只能模板上传，<50 支持在线编辑
export default {
  name: 'BatchList',
  components: { DeviceModal, CreateBatchBtn, EntProductAutoSelect, BatchQrCodeModal },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productId: null,
        vendorId: null,
        batchCode: null,
        productTypes: [1, 9]
      },
      list: [],
      total: 0,
      current: {},
      TAG_COUNT
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query,
      userDetail: state => state.account.userDetail
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('batch/getbatchs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => ({
            ...i,
            editable: i.tagCount <= TAG_COUNT
          }))
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    recall(row) {
      this.$prompt('请输入紧急召回原因', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '紧急召回原因不能为空'
      }).then(({ value }) => {
        this.loading = true
        this.$store.dispatch('inspect/recallinspectreport', {
          payload: {
            vendorId: row.vendorId,
            inspectReportId: row.inspectReportId,
            batchIds: [row.batchId],
            memo: value
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    deleteProduct(row) {
      this.$confirm('此操作将永久删除该批次, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('batch/deletebatch', {
            payload: {
              batchId: row.batchId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    deviceActions({ row, actions }) {
      console.log(row, actions)
      this.current = {
        batchId: row.batchId,
        vendorId: row.vendorId
      }
      if (actions === 1) {
        this.loading = true
        this.$store.dispatch('batch/downloadbatcheics', {
          payload: {
            batchId: row.batchId,
            vendorId: row.vendorId
          },
          success: () => {
            this.loading = false
          },
          fail: () => {
            this.loading = false
          }
        })
      }
      if (actions === 2) {
        this.$refs.upload.click()
      }
      if (actions === 3) {
        this.$nextTick(() => {
          this.$refs.modal.fetch(this.current, row.editable)
        })
      }
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('batchId', this.current.batchId)
      formData.append('vendorId', this.current.vendorId)
      this.loading = true
      this.$store.dispatch('batch/updatebatcheicsfromexcel', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.fetchList()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    downloadCode(row) {
      this.loading = true
      this.$store.dispatch('batch/downloadbatchtags', {
        payload: {
          batchId: row.batchId,
          vendorId: row.vendorId
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    addInfo(row) {
      this.$router.push(`/batch-update?vendorId=${row.vendorId}&batchId=${row.batchId}`)
    },
    preview(row) {
      this.$refs.qrcode.init(row)
    }
  }
}
</script>
